import { Faculty, StudyProgram } from '@/types';

export const facultiesData: Faculty[] = [
  {
    id: '1',
    name: 'Fakultas Ekonomi dan Bisnis',
    nameEn: 'Faculty of Economics and Business',
    slug: 'https://feb.unmul.ac.id',
    description: 'Manajemen, Akuntansi, & Ekonomi Pembangunan',
    descriptionEn: 'Management, Accounting, & Development Economics',
    icon: 'fa-chart-line',
    color: 'bg-unmulYellow',
    borderColor: 'border-unmulYellow',
    image: '/img/faculties/feb.jpg',
    programs: ['S1 Manajemen Pembangunan', 'S1 Ekonomi Syariah', 'S2 Ilmu Ekonomi', 'S1 Ilmu Ekonomi', 'S1 Manajemen', 'S2 Manajemen', 'S3 Akutansi', 'S2 Keuangan'],
    programsEn: ['Bachelor of Development Management', 'Bachelor of Islamic Economics', 'Master of Economics', 'Bachelor of Economics', 'Bachelor of Management', 'Master of Management', 'Doctoral of Accounting', 'Master of Finance'],
  },
  {
    id: '2',
    name: 'Fakultas Ilmu Sosial dan Ilmu Politik',
    nameEn: 'Faculty of Social and Political Sciences',
    slug: 'https://fisip.unmul.ac.id',
    description: 'Ilmu Sosial, Politik & Administrasi Publik',
    descriptionEn: 'Social Sciences, Political & Public Administration',
    icon: 'fa-users',
    color: 'bg-blue-600',
    borderColor: 'border-blue-600',
    image: '/img/faculties/fisip.jpg',
    programs: ['S1 Pemerintahan', 'S1 Sosial', 'S1 Administrasi Bisnis', 'S1 Administrasi Publik', 'S1 Ilmu Pemerintahan', 'S1 Hubungan Internasional', 'S2 Kesejahteraan Sosial', 'S1 Ilmu Komunikasi', 'S1 Psikologi', 'S2 Magister Administrasi Publik', 'S2 Magister Ilmu Pemerintahan'],
    programsEn: ['Bachelor of Government', 'Bachelor of Social Studies', 'Bachelor of Business Administration', 'Bachelor of Public Administration', 'Bachelor of Government Science', 'Bachelor of International Relations', 'Master of Social Welfare', 'Bachelor of Communication Science', 'Bachelor of Psychology', 'Master of Public Administration', 'Master of Government Science'],
  },
  {
    id: '3',
    name: 'Fakultas Pertanian',
    nameEn: 'Faculty of Agriculture',
    slug: 'https://faperta.unmul.ac.id',
    description: 'Agroteknologi, Agribisnis & Peternakan',
    descriptionEn: 'Agrotechnology, Agribusiness & Animal Husbandry',
    icon: 'fa-seedling',
    color: 'bg-green-500',
    borderColor: 'border-green-500',
    image: '/img/faculties/faperta.jpg',
    programs: ['S1 Agroteknologi', 'S1 Agribisnis', 'S1 Teknologi Hasil Pertanian', 'S1 Kehutanan', 'S2 Magister Pertanian Tropika Basah', 'S3 Ilmu Pertanian'],
    programsEn: ['Bachelor of Agrotechnology', 'Bachelor of Agribusiness', 'Bachelor of Agricultural Product Technology', 'Bachelor of Forestry', 'Master of Wet Tropical Agriculture', 'Doctoral of Agricultural Sciences'],
  },
  {
    id: '4',
    name: 'Fakultas Kehutanan dan Lingkungan Tropis',
    nameEn: 'Faculty of Forestry and Tropical Environment',
    slug: 'https://fahutan.unmul.ac.id',
    description: 'Pusat Unggulan Studi Tropis',
    descriptionEn: 'Center of Excellence for Tropical Studies',
    icon: 'fa-tree',
    color: 'bg-unmulGreen',
    borderColor: 'border-unmulGreen',
    image: '/img/faculties/fahutan.jpg',
    programs: ['S1 Kehutanan', 'S2 Kehutanan', 'S3 Kehutanan'],
    programsEn: ['Bachelor of Forestry', 'Master of Forestry', 'Doctoral of Forestry'],
  },
  {
    id: '5',
    name: 'Fakultas Keguruan dan Ilmu Pendidikan',
    nameEn: 'Faculty of Teacher Training and Education',
    slug: 'https://fkip.unmul.ac.id',
    description: 'Pendidikan Guru & Ilmu Kependidikan',
    descriptionEn: 'Teacher Education & Educational Sciences',
    icon: 'fa-chalkboard-teacher',
    color: 'bg-purple-500',
    borderColor: 'border-purple-500',
    image: '/img/faculties/fkip.jpg',
    programs: ['S1 Pendidikan Fisika', 'S1 Pendidikan Biologi', 'S1 Pendidikan Kimia', 'S1 Pendidikan Matematika', 'S1 Pendidikan Jasmani', 'S1 Pendidikan Komputer', 'S1 Bimbingan Konseling', 'S1 Pendidikan Bahasa Inggris', 'S1 Pendidikan Ekonomi', 'S1 Pendidikan Guru Sekolah Dasar', 'S1 Pendidikan Seni Tari', 'S2 Pendidikan Jasmani', 'S1 Pendidikan Masyarakat', 'S1 Pendidikan Geografi', 'S2 Pendidikan Bahasa', 'S1 Pendidikan Sejarah', 'S1 Pendidikan Bahasa Jerman', 'S1 Pendidikan Pancasila', 'S2 Marjorie Henderson', 'S2 Ilmu Keolahragaan Pembinaan'],
    programsEn: ['Bachelor of Physics Education', 'Bachelor of Biology Education', 'Bachelor of Chemistry Education', 'Bachelor of Mathematics Education', 'Bachelor of Physical Education', 'Bachelor of Computer Education', 'Bachelor of Counseling Guidance', 'Bachelor of English Education', 'Bachelor of Economics Education', 'Bachelor of Primary School Teacher Education', 'Bachelor of Dance Education', 'Master of Physical Education', 'Bachelor of Community Education', 'Bachelor of Geography Education', 'Master of Language Education', 'Bachelor of History Education', 'Bachelor of German Education', 'Bachelor of Pancasila Education', 'Master Marjorie Henderson', 'Master of Sports Coaching Science'],
  },
  {
    id: '6',
    name: 'Fakultas Perikanan dan Ilmu Kelautan',
    nameEn: 'Faculty of Fisheries and Marine Sciences',
    slug: 'https://fpik.unmul.ac.id',
    description: 'Akuakultur & Manajemen Sumberdaya Perairan',
    descriptionEn: 'Aquaculture & Aquatic Resources Management',
    icon: 'fa-fish',
    color: 'bg-cyan-600',
    borderColor: 'border-cyan-600',
    image: '/img/faculties/fpik.jpg',
    programs: ['S1 Akuakultur', 'S1 Teknologi Hasil Perikanan', 'S1 Sosial Ekonomi Perikanan', 'S1 Manajemen Sumberdaya Perikanan', 'S1 Ilmu Kelautan', 'S2 Magister Ilmu Perikanan'],
    programsEn: ['Bachelor of Aquaculture', 'Bachelor of Fishery Product Technology', 'Bachelor of Fishery Socio-Economics', 'Bachelor of Aquatic Resources Management', 'Bachelor of Marine Science', 'Master of Fishery Science'],
  },
  {
    id: '7',
    name: 'Fakultas Matematika dan Ilmu Pengetahuan Alam',
    nameEn: 'Faculty of Mathematics and Natural Sciences',
    slug: 'https://fmipa.unmul.ac.id',
    description: 'Sains, Matematika & Teknologi',
    descriptionEn: 'Science, Mathematics & Technology',
    icon: 'fa-atom',
    color: 'bg-indigo-600',
    borderColor: 'border-indigo-600',
    image: '/img/faculties/fmipa.jpg',
    programs: ['S1 Statistika', 'S1 Biologi', 'S1 Kimia', 'S1 Fisika', 'S1 Matematika', 'S1 Geofisika', 'S1 Ilmu Lingkungan', 'S2 Magister Geologi', 'S2 Magister Kimia'],
    programsEn: ['Bachelor of Statistics', 'Bachelor of Biology', 'Bachelor of Chemistry', 'Bachelor of Physics', 'Bachelor of Mathematics', 'Bachelor of Geophysics', 'Bachelor of Environmental Science', 'Master of Geology', 'Master of Chemistry'],
  },
  {
    id: '8',
    name: 'Fakultas Kedokteran',
    nameEn: 'Faculty of Medicine',
    slug: 'https://fk.unmul.ac.id',
    description: 'Pendidikan Dokter & Spesialis',
    descriptionEn: 'Medical Education & Specialists',
    icon: 'fa-user-md',
    color: 'bg-red-600',
    borderColor: 'border-red-600',
    image: '/img/faculties/fk.jpg',
    programs: ['S1 Kedokteran', 'Profesi Dokter', 'Spesialis Bedah', 'S1 Keperawatan', 'Profesi Ners', 'S2 Sains dan Biomedis'],
    programsEn: ['Bachelor of Medicine', 'Medical Profession', 'Surgery Specialist', 'Bachelor of Nursing', 'Nurse Profession', 'Master of Science and Biomedicine'],
  },
  {
    id: '9',
    name: 'Fakultas Teknik',
    nameEn: 'Faculty of Engineering',
    slug: 'https://ft.unmul.ac.id',
    description: 'Sipil, Mesin, Elektro, Kimia, dll.',
    descriptionEn: 'Civil, Mechanical, Electrical, Chemical, etc.',
    icon: 'fa-cogs',
    color: 'bg-gray-700',
    borderColor: 'border-gray-700',
    image: '/img/faculties/ft.jpg',
    programs: ['S2 Teknik Sipil', 'S1 Teknik Sipil', 'S1 Teknik Lingkungan', 'S1 Teknik Industri', 'S1 Teknik Geologi', 'S1 Teknik Kimia', 'S1 Teknik Pertambangan', 'S1 Teknik Mesin', 'S1 Teknik Arsitektur', 'S1 Informatika', 'S1 Sistem Informasi', 'Profesi Insinyur'],
    programsEn: ['Master of Civil Engineering', 'Bachelor of Civil Engineering', 'Bachelor of Environmental Engineering', 'Bachelor of Industrial Engineering', 'Bachelor of Geological Engineering', 'Bachelor of Chemical Engineering', 'Bachelor of Mining Engineering', 'Bachelor of Mechanical Engineering', 'Bachelor of Architecture', 'Bachelor of Informatics', 'Bachelor of Information Systems', 'Engineer Profession'],
  },
  {
    id: '10',
    name: 'Fakultas Hukum',
    nameEn: 'Faculty of Law',
    slug: 'https://fh.unmul.ac.id',
    description: 'Ilmu Hukum',
    descriptionEn: 'Legal Studies',
    icon: 'fa-gavel',
    color: 'bg-red-800',
    borderColor: 'border-red-800',
    image: '/img/faculties/fh.jpg',
    programs: ['S1 Sarjana Hukum', 'S2 Magister Hukum'],
    programsEn: ['Bachelor of Law', 'Master of Law'],
  },
  {
    id: '11',
    name: 'Fakultas Kesehatan Masyarakat',
    nameEn: 'Faculty of Public Health',
    slug: 'https://fkm.unmul.ac.id',
    description: 'Kesehatan Masyarakat & Gizi',
    descriptionEn: 'Public Health & Nutrition',
    icon: 'fa-heartbeat',
    color: 'bg-pink-500',
    borderColor: 'border-pink-500',
    image: '/img/faculties/fkm.jpg',
    programs: ['S1 Kesehatan Masyarakat', 'S1 Gizi', 'S2 Kesehatan Masyarakat'],
    programsEn: ['Bachelor of Public Health', 'Bachelor of Nutrition', 'Master of Public Health'],
  },
  {
    id: '12',
    name: 'Fakultas Farmasi',
    nameEn: 'Faculty of Pharmacy',
    slug: 'https://farmasi.unmul.ac.id',
    description: 'Farmasi Klinis & Sains Teknologi',
    descriptionEn: 'Clinical Pharmacy & Science Technology',
    icon: 'fa-pills',
    color: 'bg-teal-500',
    borderColor: 'border-teal-500',
    image: '/img/faculties/farmasi.jpg',
    programs: ['S1 Farmasi', 'Profesi Apoteker', 'S2 Magister Ilmu Farmasi', 'S2 Magister Farmasi Klinik', 'S3 Doktor Ilmu Farmasi'],
    programsEn: ['Bachelor of Pharmacy', 'Pharmacist Profession', 'Master of Pharmaceutical Science', 'Master of Clinical Pharmacy', 'Doctoral of Pharmaceutical Science'],
  },
  {
    id: '13',
    name: 'Fakultas Ilmu Budaya',
    nameEn: 'Faculty of Cultural Sciences',
    slug: 'https://fib.unmul.ac.id',
    description: 'Sastra & Ilmu Budaya',
    descriptionEn: 'Literature & Cultural Sciences',
    icon: 'fa-theater-masks',
    color: 'bg-orange-600',
    borderColor: 'border-orange-600',
    image: '/img/faculties/fib.jpg',
    programs: ['S1 Sastra Indonesia', 'S1 Sastra Inggris', 'S1 Etnomusikologi', 'S1 Sastra Mulawarman'],
    programsEn: ['Bachelor of Indonesian Literature', 'Bachelor of English Literature', 'Bachelor of Ethnomusicology', 'Bachelor of Mulawarman Literature'],
  },
  {
    id: '14',
    name: 'Fakultas Kedokteran Gigi',
    nameEn: 'Faculty of Dentistry',
    slug: 'https://fkg.unmul.ac.id',
    description: 'Kedokteran Gigi & Profesi',
    descriptionEn: 'Dentistry & Profession',
    icon: 'fa-tooth',
    color: 'bg-sky-500',
    borderColor: 'border-sky-500',
    image: '/img/faculties/fkg.jpg',
    programs: ['S1 Kedokteran Gigi', 'Profesi Dokter Gigi'],
    programsEn: ['Bachelor of Dentistry', 'Dentist Profession'],
  },
  {
    id: '15',
    name: 'Pascasarjana',
    nameEn: 'Postgraduate School',
    slug: 'https://pasca.unmul.ac.id',
    description: 'Program Magister (S2) & Doktor (S3)',
    descriptionEn: 'Master (S2) & Doctoral (S3) Programs',
    icon: 'fa-user-graduate',
    color: 'bg-black',
    borderColor: 'border-black',
    image: '/img/faculties/pasca.jpg',
    programs: ['S2 Ilmu Lingkungan', 'S3 Ilmu Lingkungan'],
    programsEn: ['Master of Environmental Science', 'Doctoral of Environmental Science'],
  },
];

export const kehutananPrograms: StudyProgram[] = [
  {
    id: '1',
    name: 'S1 Kehutanan',
    level: 'S1',
    accreditation: 'A (Unggul)',
    description: 'Mempelajari ilmu pengelolaan hutan berkelanjutan, konservasi biodiversitas, dan ekologi.',
    borderColor: 'border-unmulGreen',
  },
  {
    id: '2',
    name: 'S1 Rekayasa Kehutanan',
    level: 'S1',
    accreditation: 'A',
    description: 'Fokus pada teknologi pengolahan hasil hutan dan industri kehutanan.',
    borderColor: 'border-unmulYellow',
  },
  {
    id: '3',
    name: 'S2 Ilmu Kehutanan',
    level: 'S2',
    accreditation: 'A',
    description: 'Program magister dengan fokus riset kehutanan tropis.',
    borderColor: 'border-blue-500',
  },
  {
    id: '4',
    name: 'S3 Ilmu Kehutanan',
    level: 'S3',
    accreditation: 'B',
    description: 'Program doktor untuk penelitian lanjutan bidang kehutanan.',
    borderColor: 'border-purple-500',
  },
  {
    id: '5',
    name: 'Profesi Rimbawan',
    level: 'Profesi',
    accreditation: 'Program Profesi',
    description: 'Sertifikasi profesional untuk praktisi kehutanan.',
    borderColor: 'border-green-500',
  },
];
